import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as ExaminationActions from '../actions/examination.actions';
import { ExaminationService } from '../../service/examination.service';
import { ExaminationList } from '../../model/examination.model';

@Injectable()
export class ExaminationEffects {

    constructor(
        private actions: Actions,
        private _examinationService: ExaminationService,
    ) { }

    getExamination = createEffect(() => this.actions.pipe(
        ofType(ExaminationActions.GetExamination),
        exhaustMap(action => {
            return this._examinationService.getExaminations(action.params).pipe(
                map((examinations: ExaminationList) => {
                    return ExaminationActions.GetExaminationSuccess({ payload: examinations });
                }),
                catchError(() => of(ExaminationActions.GetExaminationFailure()))
            )
        })
    ));

    getDocumentFromUrl = createEffect(() => this.actions.pipe(
        ofType(ExaminationActions.GetExaminationfromurl),
        exhaustMap(action => {
            return this._examinationService.getExaminationsByUrl(action.url).pipe(
                map((examinations: ExaminationList) => {
                    return ExaminationActions.GetExaminationSuccess({ payload: examinations });
                }),
                catchError(() => of(ExaminationActions.GetExaminationFailure()))
            )
        })
    ));
}

